<template>
    <div class="">
        <div v-if="loading">
            Loading ...
        </div>
        <div v-if="!loading">

            <div class="bg-grey-lighter py-8">

                <div class="max-w-screen-xl px-6 mx-auto">

                    <p>
                        Source: {{ source }}.
                    </p>

                    <div class="mt-8">

                        <div class="">

                            <nav v-if="false" class="">
                                <div class="container">
                                    <div class="row">
                                        <div class="col-xs-4" style="padding-top:8px;">
                                            <a
                                                    class="pull-left btn btn-link"
                                                    v-if="this.active > 0"
                                                    v-on:click="previous()"
                                            >
                                                <i class="fa fa-chevron-left"></i>
                                                Previous
                                            </a>
                                        </div>
                                        <div class="col-xs-4" style="padding-top:14px">
                                            <p class="text-center">
                                                Step
                                                {{ !chartActive ? active + 1 : tabs.length + 1 }}
                                                of
                                                {{ tabs.length + 1 }}
                                            </p>
                                        </div>
                                        <div class="col-xs-4" style="padding-top:8px">
                                            <a
                                                    class="pull-right btn"
                                                    v-if="!chartActive"
                                                    v-on:click="next()"
                                                    v-bind:class="{
                                            'btn-default': !isTabReady,
                                            'btn-primary': isTabReady
                                            }"
                                            >
                                                Next
                                                <i class="fa fa-chevron-right"></i>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </nav>

                            <div class="flex">
                                <div class="w-1/4 pr-4 text-grey">

                                    <div>
                                        <ul class="list-reset ">
                                            <li
                                                    v-for="tab in tabs"
                                            >
                                                <a
                                                        class="p-2 flex cursor-pointer hover:text-black hover:bg-white hover:border-blue-dark"
                                                        :class="{
                                                        'text-black bg-white border-l-4 border-blue-dark': isActive(tab),
                                                        '': this.active > tab.id && count(tab) > 0
                                                    }"
                                                        v-on:click="makeActive(tab)">
                                                    <span
                                                            class="pl-2"
                                                    >
                                                        {{ tab.value.translations.en }}
                                                    </span>

                                                    <ul class="hidden ml-4 list-reset p-2">
                                                        <li
                                                                class="cursor-pointer hover:text-red"
                                                                v-for="code in equals(storage.selected, tab.value)"
                                                                v-on:click="deselectItem(code, $event)"
                                                        >
                                                            {{ code.translations.en }}
                                                            <i class="fa fa-times"></i>
                                                        </li>
                                                    </ul>
                                                </a>
                                            </li>
                                        </ul>

                                        <div class="border-t">
                                            <a class="flex p-2 cursor-pointer hover:text-black hover:bg-white hover:border-blue-dark"
                                               :class="{'text-black bg-white border-l-4 border-blue-dark': chartActive}"
                                               v-on:click="activateChart()">
                                                    <span class="pl-2">
                                                        Data
                                                    </span>
                                            </a>
                                        </div>


                                    </div>

                                </div>

                                <div class="bg-white shadow w-2/3 p-4">
                                    <div class="">
                                        <div
                                                v-for="(tab, index) in tabs"
                                                class=""
                                        >
                                            <stepy :id="1" :active="isActive(tab)" @active="makeActive(tab)">
                                                <span slot="number">{{ index + 1}}</span>
                                                <span slot="headline">{{ tab.value.translations.en }}</span>
                                                <slot>
                                                    <bar
                                                            class=""
                                                            :item="tab.value"
                                                    >
                                                    </bar>
                                                    <div class="my-8">
                                                        <a
                                                                class="btn"
                                                                v-if="!chartActive"
                                                                v-on:click="next()"
                                                                :class="{
                                                                'btn-default': !isTabReady,
                                                                'btn-primary': isTabReady
                                                                }"
                                                        >
                                                            Continue
                                                        </a>
                                                        <a
                                                                class="ml-8 btn btn-link"
                                                                v-if="this.active > 0"
                                                                v-on:click="previous()"
                                                        >
                                                            Previous
                                                        </a>
                                                    </div>

                                                </slot>
                                                <div slot="inactive">

                                                    <ul class="ml-4 list-reset p-2">
                                                        <li
                                                                class="cursor-pointer hover:text-red"
                                                                v-for="code in equals(storage.selected, tab.value)"
                                                                v-on:click="deselectItem(code, $event)"
                                                        >
                                                            {{ code.translations.en }}
                                                            <i class="fa fa-times"></i>
                                                        </li>
                                                        <li v-show="equals(storage.selected, tab.value).length == 0">
                                                            Any
                                                        </li>
                                                    </ul>

                                                </div>
                                            </stepy>
                                        </div>

                                        <div>
                                            <stepy :active="chartActive" last="true">
                                                <span slot="number">{{ tabs.length + 1 }}</span>
                                                <span slot="headline">Data</span>
                                                <slot>
                                                    <dsi-chart
                                                            :code-lists="codeLists"
                                                    >
                                                    </dsi-chart>
                                                    <div slot="inactive"></div>
                                                </slot>
                                            </stepy>
                                        </div>
                                    </div>

                                    <div v-if="false" class="bg-purple-dark flex justify-between">
                                        <div class="">
                                            <a
                                                    class="pull-left btn btn-link"
                                                    v-if="this.active > 0"
                                                    v-on:click="previous()"
                                            >
                                                <i class="fa fa-chevron-left"></i>
                                                Previous
                                            </a>
                                        </div>
                                        <div class="">
                                            <p class="text-center">
                                                Step {{ !chartActive ? active + 1 : tabs.length + 1 }} of {{ tabs.length
                                                + 1
                                                }}
                                            </p>
                                        </div>
                                        <div class="">
                                            <a
                                                    class="pull-right btn"
                                                    v-if="!chartActive"
                                                    v-on:click="next()"
                                                    :class="{
                                                    'btn-default': !isTabReady,
                                                    'btn-primary': isTabReady
                                                }"
                                            >
                                                Next
                                                <i class="fa fa-chevron-right"></i>
                                            </a>
                                        </div>
                                    </div>

                                </div>

                            </div>

                        </div>

                    </div>

                </div>

            </div>

        </div>
    </div>

</template>

<script>

    export default {

        data: function () {
            return {
                storage: storage,
                tabs: [],
                active: 0,
                charts: [],
                chartActive: false,
                chartReady: false,
                codeLists: [],
                getSelected: [],
                pathes: [],
                indicator: {},
                disabledStates: [],
                sources: [],
                source: null,
                loading: true,
            }
        },

        watch: {
            'storage.selected': 'updateGetSelected',
        },

        computed: {
            isTabReady: function () {
                return this.count(this.activeTab()) > 0;
            },
            description: function () {
                if (this.chartActive) {
                    return '';
                }
                return this.activeTab().value.translations.en;
            }
        },

        mounted: function () {

            const that = this;

            window.http
                .get('/api/v1/indicators/' + this.storage.database)
                .then((response) => {
                    var foo = response.data.indicator.code_lists;
                    that.codeLists = response.data.indicator.code_lists;
                    that.indicator = response.data.indicator;
                    that.pathes = response.data.path;
                    that.sources = response.data.sources.map(function (source) {
                        return {
                            'source': source
                        };
                    });

                    that.source = response.data.sources.join(' & ');

                    let id = 0;
                    that.tabs = foo.map(function (value) {
                        const bar = {
                            id: id,
                            type: 'codeList',
                            value: value
                        };
                        id++;

                        return bar;
                    });

                    this.loading = false;
                });
        },

        methods: {
            updateGetSelected: function () {
                this.updateAvailability();
                this.chartReadyCheck();
                this.updateRouter();
            },

            getFilter: function () {
                var obj = {};
                const that = this;

                this.codeLists.forEach(function (cl) {
                    const id = cl.id;
                    obj[id] = that.storage.selected.filter(function (code) {
                        return code.code_list === cl.id;
                    }).map(function (code) {
                        return code.id
                    });
                });

                return obj;
            },

            selectItem: function (item) {
                this.storage.selectItem(item);
            },

            deselectItem: function (item, event) {
                event.stopPropagation();
                this.storage.deselectItem(item);
            },

            updateAvailability: function () {

                var obj = this.getFilter();

                window.http
                    .get(
                        '/api/v1/indicators/' + this.storage.database + '/dimensions/available',
                        {
                            params: {
                                filters: obj
                            }
                        }
                    )
                    .then((response) => {
                            this.disabledStates = response.data.disabled;
                            this.storage.updateState(response.data.disabled);
                        }, response => {
                            this.disabledStates = [];
                        }
                    );
            },

            isDisabledCode: function (dimension, item) {
                var bar = this.disabledStates[dimension];
                if (!bar) {
                    return true;
                }

                var result = bar.find(function (element) {
                    return element == item.id;
                });

                return result === undefined;
            },
            updateRouter: function () {

                var obj = {};
                var that = this;
                this.codeLists.forEach(function (value) {

                    var id = value.id;
                    obj[id] = that.storage.selected.filter(function (code) {
                        return code.code_list === value.id
                    }).map(function (code) {
                        return code.id
                    });

                });

            },

            activeTab: function () {
                if (this.chartActive) {
                    return 'Chart'
                }
                return this.tabs[this.active];
            },

            nextTab: function () {
                if (this.active + 1 < this.tabs.length) {
                    var tab = this.tabs[this.active + 1];
                    return tab.value.translations.en;
                }
                return 'Chart';
            },

            previousTab: function () {
                if (this.chartActive) {
                    var tab = this.tabs[this.tabs.length - 1];
                    return tab.value.translations.en;
                }
                return this.tabs[this.active - 1].value.translations.en;
            },

            chartReadyCheck: function () {
                var that = this;
                this.chartReady = this.tabs.map(function (tab) {
                    var equals = that.equals(that.storage.selected, tab.value);
                    return equals.length > 0;
                }).reduce(function (previousValue, currentValue) {
                    if (!previousValue) {
                        return false;
                    }
                    return currentValue;
                }, true);
            },
            count: function (tab) {
                const id = tab.value.id;
                const filtered = this.storage.selected.filter(function (value) {
                    return value.code_list === id;
                });

                return filtered.length;
            },

            hasPrevious: function () {
                return this.active > 0;
            },
            isActive: function (tab) {
                return !this.chartActive && tab.id === this.active;
            },
            makeActive: function (tab) {
                this.chartActive = false;
                this.active = tab.id;
            },
            activateChart: function () {
                this.active = this.tabs[this.tabs.length - 1].id + 1;
                this.chartActive = true;
            },
            equals: function (codes, cl) {
                let grr = codes.filter(function (code) {
                    return cl.id === code.code_list;
                });

                return _.sortBy(grr, 'translations.en');
            },
            next: function () {
                if (this.active + 1 < this.tabs.length) {
                    return this.makeActive(this.tabs[this.active + 1]);
                }

                return this.activateChart();
            },

            previous: function () {
                if (this.chartActive) {
                    return this.makeActive(this.tabs[this.tabs.length - 1])
                }
                return this.makeActive(this.tabs[this.active - 1]);
            }
        },

    }

</script>

<style>
    /* * { outline: 1px solid red !important; } */
</style>
